import type { Nullable } from "@iot-platform/core";
import { FallbackError } from "@iot-platform/core";
import { UserDatasource } from "@user/data/datasources/user.datasource";
import type {
    User,
    UserCreate,
    UserEdit,
    UserResume,
} from "@user/domain/models/user.model";
import { Users } from "@user/domain/models/user.model";
import type { UserRepository } from "@user/domain/repositories/user.repository";
import { inject, injectable } from "inversify";
import { ResultAsync } from "neverthrow";

@injectable()
export class UserImplRepository implements UserRepository {
    constructor(
        @inject(UserDatasource)
        private readonly userDatasource: UserDatasource,
    ) {}

    getAllResume(): ResultAsync<Users, FallbackError> {
        return this.userDatasource.fetchAllResume();
    }

    getByEmail(
        email: string,
    ): ResultAsync<Nullable<UserResume>, FallbackError> {
        return this.userDatasource.fetchResumeByEmail(email);
    }

    getById(id: number): ResultAsync<User, FallbackError> {
        return this.userDatasource.fetchById(id);
    }

    create(createUser: UserCreate): ResultAsync<User, FallbackError> {
        return this.userDatasource.create(createUser);
    }

    delete(id: number): ResultAsync<boolean, FallbackError> {
        return this.userDatasource.delete(id);
    }

    edit(editUser: UserEdit): ResultAsync<User, FallbackError> {
        return this.userDatasource.edit(editUser);
    }
}
